import { render } from "./NeobuqCarbonView.vue?vue&type=template&id=c60e5f04&scoped=true"
import script from "./NeobuqCarbonView.vue?vue&type=script&lang=js"
export * from "./NeobuqCarbonView.vue?vue&type=script&lang=js"

import "./NeobuqCarbonView.vue?vue&type=style&index=0&id=c60e5f04&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60e5f04"]])

export default __exports__